import React from 'react';
import { companyInfo } from '../mockData';

const Logo = ({ className = "", textColor = "text-white" }) => {
  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Modern Fire/Cinder Icon */}
      <svg 
        width="40" 
        height="40" 
        viewBox="0 0 40 40" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="flex-shrink-0"
      >
        {/* Outer glow */}
        <circle 
          cx="20" 
          cy="20" 
          r="18" 
          className={textColor === "text-white" ? "fill-white" : "fill-orange-200"}
          opacity="0.15"
        />
        
        {/* Flame shape - Modern geometric */}
        <path 
          d="M20 8 C18 12, 16 16, 16 20 C16 24, 17 28, 20 30 C23 28, 24 24, 24 20 C24 16, 22 12, 20 8 Z" 
          className={textColor === "text-white" ? "fill-white" : "fill-orange-500"}
          opacity="0.9"
        />
        
        {/* Inner flame */}
        <path 
          d="M20 14 C19 16, 18 18, 18 20 C18 22, 19 24, 20 25 C21 24, 22 22, 22 20 C22 18, 21 16, 20 14 Z" 
          className={textColor === "text-white" ? "fill-white" : "fill-orange-300"}
          opacity="0.7"
        />
        
        {/* Core ember */}
        <circle 
          cx="20" 
          cy="20" 
          r="3" 
          className={textColor === "text-white" ? "fill-white" : "fill-orange-200"}
        />
        
        {/* Modern sparkles */}
        <circle cx="28" cy="15" r="1.5" className={textColor === "text-white" ? "fill-white" : "fill-orange-400"} opacity="0.8"/>
        <circle cx="12" cy="22" r="1.5" className={textColor === "text-white" ? "fill-white" : "fill-orange-400"} opacity="0.8"/>
        <circle cx="26" cy="26" r="1" className={textColor === "text-white" ? "fill-white" : "fill-orange-300"} opacity="0.6"/>
      </svg>
      
      {/* Modern Typography */}
      <div className="flex flex-col leading-tight">
        <span className={`font-black text-2xl tracking-tight ${textColor}`}>
          Cinderhillx
        </span>
      </div>
    </div>
  );
};

export default Logo;
